"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Basisklasse für Item-Widgets.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe auch {@link gc.gis.widget.GCWidget})
 */
gc.gis.widget.GCItem = function( options )
{
	this.label              = options.label;
	this.icon               = options.icon;
	this.tooltip            = options.tooltip;
	this.action             = options.action;
	this.click              = options.click;
	this.containerClassName = options.containerClassName;
	this.badge              = options.badge;

	gc.gis.widget.GCWidget.call( this, options );
};
gc.gis.widget.GCItem.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * Setzt die Aktion, die beim Betätigen des Items ausgeführt wird.
 *
 * @method
 * @public
 * @param {{gc.gis.action.GCAbstractAction}} action
 */
gc.gis.widget.GCItem.prototype.setAction = function(action)
{
	this.action = action;
};

/**
 * Führt die Aktion aus.
 *
 * @method
 * @public
 */
gc.gis.widget.GCItem.prototype.execute = function()
{
	if(this.action)
	{
		this.action.execute();
	}
};

/**
 * Setzt den Status des Widgets auf <code>active</code>.
 *
 * @method
 * @public
 * @param {boolean} active
 */
gc.gis.widget.GCItem.prototype.setActive = function(active)
{
	if(active === true)
	{
		this.getElement().addClass('active');
	}
	else
	{
		this.getElement().removeClass('active');
	}
};

/**
 * Liefert den Status des Widgets.
 *
 * @method
 * @public
 */
gc.gis.widget.GCItem.prototype.isActive = function()
{
	return this.getElement().hasClass('active');
};

/**
 * Sperrt oder entsperrt ein Widget.
 *
 * @method
 * @public
 * @param {boolean} enabled
 */
gc.gis.widget.GCItem.prototype.setEnabled = function(enabled)
{
	var element = this.getElement();    // !! render das Element und das element_control (daher zu Beginn aufrufen)

	if(this.element_control)
	{
		this.element_control.prop('disabled', (enabled !== true));
		this.element_control.attr('disabled', (enabled !== true));
	}

	if(enabled !== true)
	{
		element.addClass('disabled');
	}
	else
	{
		element.removeClass('disabled');
	}
};

/**
 * Zeigt an, ab das Widget gesperrt ist.
 *
 * @method
 * @public
 */
gc.gis.widget.GCItem.prototype.isEnabled = function()
{
	if(this.element_control)
	{
		return !this.element_control.prop('disabled');
	}
};

/**
 * Gibt das jQuery-Steuerelement-Element des Widgets zurück, sofern dies bereits existiert.
 *
 * @method
 * @public
 * @return {jQuery}
 */
gc.gis.widget.GCItem.prototype.getElementControl = function()
{
	return this.element_control;
};

/**
 * Setzt den Tooltip des Elements.
 *
 * @method
 * @public
 * @param {string} tooltip
 */
gc.gis.widget.GCItem.prototype.setTooltip = function(tooltip)
{
	var ctrl = this.getElementControl();

	this.tooltip = tooltip;
	if (ctrl)
	{
		ctrl.attr('data-original-title', this.tooltip);
	}
};

/**
 * @inheritDoc
 */
gc.gis.widget.GCItem.prototype._render = function()
{
	var self = this;

	// Labeltext
	var element_label_text = jQuery('<span>', {
		'class': 'gc-widget-label-text',
		text: (self.label ? self.label : '')
	});

	// Control
	this.element_control = jQuery('<a>', {
		href: '#',
		title: self.tooltip ? self.tooltip : self.label,
		'class': 'gc-button gc-widget-label'
			+ (self.tooltip ? ' gc-widget-tooltip' : '')
			+ (self.badge ? ' gc-widget-badge' : '')
			+ (self.className ? ' '+ self.className : ''),
		click: function( evt ) {
			evt.preventDefault();
			try
			{
                if(self.action)
                {
                    self.action.execute(self);
                }
                if(self.click)
                {
                    self.click.call(self, evt);
                }
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
			jQuery(this).blur();
		}
	});

	if( self.icon ) {
		this.element_control.append( jQuery('<span>', {
			'class': 'gc-icon '+ self.icon
		}) );
	}
	if( self.label ) {
		this.element_control.append( element_label_text );
	}
	if(self.tooltip)
	{
		gc.gis.iface.ui.tooltip(self.element_control, {
			placement: 'auto right'
		});
	}
	if( self.badge ) {
		this.element_control.append( self.badge.getElement() );
	}

	// Container
	var item = jQuery('<div>', {
		'class': 'gc-widget gc-widget-item'
			+ (self.containerClassName ? ' '+ self.containerClassName : '')
	});
	item.append( this.element_control );

	return item;
};

